import { render, staticRenderFns } from "./list.vue?vue&type=template&id=8886f9be&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=8886f9be&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8886f9be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8886f9be')) {
      api.createRecord('8886f9be', component.options)
    } else {
      api.reload('8886f9be', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=8886f9be&scoped=true&", function () {
      api.rerender('8886f9be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/tokenList/list.vue"
export default component.exports